<template>
  <div class="mx-auto container container--fluid">
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-data-table :headers="headers" :items="interest_master_list" class="elevation-1 mytable" denses :search="search">
        <template v-slot:top>
          <v-toolbar dense class="toolbar" flat color="white">
            <v-toolbar-title>Interest</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>

          <span style="width: 20px"> </span>
          <v-row justify="center" dense>
            <v-col sm="3" md="8" cols="12"> </v-col>
            <v-col sm="6" md="6" cols="12">
              <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
              </v-text-field>
            </v-col>
            <span style="width: 20px"></span>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn class="mb-2 button" v-on="on" small>Add Interest</v-btn>
              </template>
              <v-card>
                <v-form v-model="valid">
                  <v-card-title class="toolbar">
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                          <v-autocomplete :items="interest_super_master_list" v-model="addedItem.interest_super_master_list"
                            label="Select Interest" :rules="[(v) => !!v || 'required']"></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                          <v-text-field v-model="editedItem.interest" persistent-hint :disabled="editedIndex != -1" label="Interest" :rules="[(v) => !!v || 'required']"></v-text-field>
                        </v-col>
                        <v-col cols="12" v-if="editedIndex != -1">
                          <v-checkbox dense v-model="editedItem.isactive" color="success" label="Active?"></v-checkbox>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                    <v-btn class="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-row>
        </template>

        <template v-slot:item.isactive="{ item }">
          <span v-if="item.isactive">
            <v-icon class="mr-2 v-icon-size" color="success" title="Active">mdi-check-circle-outline</v-icon>
          </span>
          <span v-else>
            <v-icon class="mr-2 v-icon-size" color="error" title="Not Active">mdi-close-circle-outline</v-icon>
          </span>
        </template>

        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
            </v-avatar>
          </div>
        </template>
      </v-data-table>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    valid: false,
    interest_super_master_list: "",
    overlay: false,
    errorMsg: {
      interest: false,
    },
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    interest_super_master_list: null,
    displayname: "",
    headers: [
      {
        text: "Interest",
        align: "left",
        sortable: false,
        value: "interest",
      },
      {
        text: "Isactive",
        align: "left",
        sortable: false,
        value: "isactive",
      },

      { text: "Actions", value: "action", sortable: false },
    ],
    interest_master_list: [],
    editedIndex: -1,
    addedItem: {
      interest_super_master_list: "",
    },
    editedItem: {
      id: "",
      interest: "",
      isactive: false,
    },
    defaultItem: {
      id: "",
      interest: "",
      isactive: false,
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Interest" : "Edit Interest";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    editItem(item) {
      this.editedIndex = this.interest_master_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    onLoad() {
      this.overlay = true;
      axios
        .post("/AdmissionMaster/interest")
        .then((res) => {
          if (res.data.msg == "200") {
            if ((this.load = true)) {
              this.overlay = false;
              this.interest_master_list = res.data.interest_master_list;
              this.interest_super_master_list = res.data.interest_super_master_list;
            }
          } else {
            window.console.log(res.data.msg);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); 
          window.console.log(error);
        })
        .finally(() => {
          "use strict";
          var overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          axios
            .post("/AdmissionMaster/editInterest", this.editedItem)
            .then((res) => {
              if (res.data.msg == "200") {
                Object.assign(
                  this.interest_master_list[this.editedIndex],
                  this.editedItem
                );
              }
              this.showSnackbar("#4caf50", "Interest Updated Successfully..."); 
            })
            .catch((error) => {
              window.console.log(error);
            });
          this.close();
        }
      } else {
        axios
          .post("/AdmissionMaster/saveInterest", this.addedItem)
          .then((res) => {
            if (res.data.status.code == "SUCCESS") {
              this.interest_master_list.push(this.addedItem);
              this.showSnackbar("#4caf50", "Interest Added Successfully!!!"); 
              this.onLoad();
            } else if (res.data.status.code == "NA") {
              this.showSnackbar("#b71c1c", "Interest Already Present!!!");
            }
          })
          .catch((error) => {
            window.console.log(error);
          });
        this.close();
      }
    }, 

    isValidated() {
      if (this.editedItem.interest) {
        return true;
      } else {
        if (!this.editedItem.interest) {
          this.errorMsg.interest = true;
        }

        return false;
      }
    }, 
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
</style>